/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React from 'react';
import {Dropdown, Menu, MenuHeading, MenuItemCheckbox} from "@ice/components";
import {getAppComponent, getMapComponent} from "../store/Accessor";
import {getAppState} from "../store/AppState";
import {AppThemeType, MapStyle} from "../types";
import {XIcon} from "../ui/XIcon";
import {IconInfo} from "../util/IconInfo";
import {$t} from "../lang/LangUtil";


interface MainMenuProps {
}


interface MainMenuState {
}


export default class MainMenu extends React.Component<MainMenuProps, MainMenuState> {

    constructor(props: MainMenuProps) {
        super(props);
        this.state = {
        };
    }

    private createMenuButton = (
        icon: IconInfo,
        title: string,
        menuItemsCreator: () => any,
        onClick?: () => void,
        selected?: boolean
    ) => {
        return (
            <Dropdown
                minimal
                noCaret
                nopad
                aria-atomic
                placement={"left-start"}
                title={title}
                onClick={onClick}
                renderMenu={getProps => (
                    menuItemsCreator &&
                    <Menu id="dropdown-menu" {...getProps()}>
                        {menuItemsCreator()}
                    </Menu>
                )}
                css={(theme) => css`
                      border-radius: 0;
                      background-color: ${theme.dark ? "rgba(0, 0, 0, 0.8)": "rgba(255, 255, 255, 0.8)"};
                      border: solid 1px ${theme.dark ? "rgba(128, 128, 128, 0.4)" : "rgba(128, 128, 128, 0.25)"};
                      &:hover {
                        ${`background-color: ${theme.datePicker.hover.backgroundColor};`}
                      }
                    `}
            >
                <XIcon icon={icon} title={title} iconSize={"1.5rem"}  css={(theme) => css`fill: ${selected ? theme.selectionColor : theme.textColor.default}; margin: 0.6em`} />
            </Dropdown>
        );
    }

    render = () => {
        const appState = getAppState();
        const currTheme = appState.getThemeType();
        const currStyle = appState.getMapStyle();

        const setMapStyle = (style: MapStyle) => {
            appState.setMapStyle(style);
            getAppComponent().refresh();
        }

        const mapStyleMenuItems = () => (
            <React.Fragment>
                <MenuHeading text={$t("mapstyle")} />
                <MenuItemCheckbox text={$t("standard")} checked={currStyle === MapStyle.standard} onClick={() => setMapStyle(MapStyle.standard)} />
                <MenuItemCheckbox text={$t("terrain")} checked={currStyle === MapStyle.terrain} onClick={() => setMapStyle(MapStyle.terrain)} />
                <MenuItemCheckbox text={$t("satellite")} checked={currStyle === MapStyle.satellite} onClick={() => setMapStyle(MapStyle.satellite)} />
            </React.Fragment>
        );

        const mapComponent = getMapComponent();

        const mapViewMenuItems = () => (
            <React.Fragment>
                <MenuHeading text={$t("mapview")} />
                <MenuItemCheckbox text="2D" checked={mapComponent.is2D()} onClick={() => {
                    mapComponent.set2D();
                    getAppComponent().refresh();
                }} />
                <MenuItemCheckbox text="3D" checked={!mapComponent.is2D()} onClick={() => {
                    mapComponent.set3D();
                    getAppComponent().refresh();
                }} />
            </React.Fragment>
        );

        const themeMenuItems = () => (
            <React.Fragment>
                <MenuHeading text={$t("theme")} />
                {
                    Object.keys(AppThemeType).map(t =>
                        <MenuItemCheckbox text={$t(t as any)} checked={t === currTheme} onClick={() => {
                            appState.setThemeType(t as AppThemeType);
                            getMapComponent()?.recreateLayers();
                            getAppComponent().refresh();
                        }} />
                    )
                }
            </React.Fragment>
        );

        return (
            <div key={`mm_${Date.now()}`} style={{display: "flex", flexDirection: "column", position: "fixed", right: "0.4em", top: "2em"}}>
                {this.createMenuButton(IconInfo.MAP, $t("mapstyle"), mapStyleMenuItems)}
                <div style={{height: "0.4em"}} />
                {this.createMenuButton(IconInfo.BOX, $t("mapview"),  mapViewMenuItems)}
                <div style={{height: "0.4em"}} />
                {this.createMenuButton(IconInfo.SUN, $t("theme"), themeMenuItems)}
                <div style={{height: "0.4em"}} />
                {this.createMenuButton(IconInfo.LEGEND, $t("legend"), null, () => {
                    appState.setShowLegend(!appState.isShowLegend());
                    getAppComponent().refresh();
                }, appState.isShowLegend())}
            </div>
        );
    }
}
